import api from 'utils/api';
import { objectToQueryString } from 'utils/helpers';

const servicePath = '/services/recovery-price';

export const create = async (details) => {
  const { data } = await api.post(servicePath, details);

  return data;
}

export const getVersions = async () => {
  const response = await api.post(`${servicePath}/get-versions`, { type: 'NTK pastatai' });
  const versions = response.data;
  
  return versions;
}